import { Check } from "lucide-react";

const BeforeAndAfterComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-01">
      <div className="max-w-6xl mx-auto custom-color-03">
        <h3 className="text-3xl font-bold text-center mb-12">
          Como sua prática de aconselhamento pode ser transformada
        </h3>
        <div className="grid md:grid-cols-2 gap-12">
          <div className="text-center">
            <h4 className="text-2xl font-semibold mb-6">Antes</h4>
            <div className="rounded-2xl p-8 custom-bg-color-03 custom-color-01">
              <ul className="space-y-4 text-left">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0 custom-bg-color-05"></div>
                  <span>Insegurança diante de problemas complexos</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0 custom-bg-color-05"></div>
                  <span>Frustração com resultados superficiais</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0 custom-bg-color-05"></div>
                  <span>Dependência de métodos seculares</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full mt-2 flex-shrink-0 custom-bg-color-05"></div>
                  <span>Dúvidas sobre a suficiência bíblica</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center">
            <h4 className="text-2xl font-semibold mb-6">Depois</h4>
            <div className="rounded-2xl p-8 border  custom-bg-color-02 custom-color-01">
              <ul className="space-y-4 text-left">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-05" />
                  <span>
                    Clareza para aplicar princípios bíblicos no processo da
                    mudança
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-05" />
                  <span>
                    Confiança para lidar com questões emocionais e espirituais
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0  custom-color-05" />
                  <span>Ferramentas práticas para promover mudança real</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-05" />
                  <span>Convicção renovada na suficiência das Escrituras</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BeforeAndAfterComponent;
